import m from "../../geodata/es2015/usaTerritoriesHigh";
window.am4geodata_usaTerritoriesHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/usaTerritoriesHigh.js
// module id = null
// module chunks = 